/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface AffiliateRequest {

    /**
     * Uuid of the user affiliate
     */
    user_uuid?: string;

    shortlist_id?: number[];

    /**
     * Status of this affiliate
     */
    status?: string;

    /**
     * When the affiliate completed the signup process
     */
    signed_up_at?: string;

    /**
     * When the affiliate completed the onboarding process
     */
    onboarded_at?: string;

    /**
     * When the affiliate was offboarded 
     */
    offboarded_at?: string;

    /**
     * When the affiliate was banned
     */
    banned_at?: string;

    /**
     * Link to take the affiliate to Shortlist
     */
    shortlist_url?: string;

    /**
     * Link to the affiliate's join offer
     */
    offer_url?: string;

    /**
     * Hide username and avatar from leaderboard
     */
    keep_leaderboard_private?: boolean;

    /**
     * Affiliate's display name
     */
    username?: string;

    /**
     * Avatar URL
     */
    avatar?: string;

}

@Model('Affiliate')
export class ApiAffiliate extends BaseModel implements AffiliateRequest {

    /**
     * Uuid of the user affiliate
     */
    
    
    user_uuid: string;

    
    
    shortlist_id: number[];

    /**
     * Status of this affiliate
     */
    
    
    status: string;

    /**
     * When the affiliate completed the signup process
     */
    
    
    signed_up_at: string;

    /**
     * When the affiliate completed the onboarding process
     */
    
    
    onboarded_at: string;

    /**
     * When the affiliate was offboarded 
     */
    
    
    offboarded_at: string;

    /**
     * When the affiliate was banned
     */
    
    
    banned_at: string;

    /**
     * Link to take the affiliate to Shortlist
     */
    
    
    shortlist_url: string;

    /**
     * Link to the affiliate's join offer
     */
    
    
    offer_url: string;

    /**
     * Hide username and avatar from leaderboard
     */
    
    
    keep_leaderboard_private: boolean;

    /**
     * Affiliate's display name
     */
    
    
    username: string;

    /**
     * Avatar URL
     */
    
    
    avatar: string;

}
